import { createRelayResource } from '@townsquare/relay-utils';
import type { HomeResourceContext } from '@townsquare/router/types';

import KudosDirectoryQuery, {
	KudosDirectoryQuery as KudosDirectoryQueryType,
} from '../__generated__/KudosDirectoryQuery.graphql';

export const kudosDirectoryResource = createRelayResource<KudosDirectoryQueryType>({
	getQuery: (_routerContext, resourceContext) => {
		const context = resourceContext as HomeResourceContext;
		const workspaceId = context.workspace?.globalId ?? '';

		return {
			query: KudosDirectoryQuery,
			variables: {
				workspaceId,
			},
			cacheKey: 'relay-kudos-directory',
			options: { fetchPolicy: 'store-and-network' },
		};
	},
});
